export default __webpack_public_path__ + "static/media/step.0656c308.svg";